import { useContext, useEffect, useRef, useState, Fragment } from 'react'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import styles from './styles.module.css'
import { StudentsContext } from '../../../utils/context'
import Loader from '../../../components/Loader'
import { getStudentTable } from '../../../actions/students/other'

export default function IOT() {
  const { allForms, addMode, studentTabData, updateInitialValues, studentId, currentTabLoading } = useContext(StudentsContext)

  const dispatch = useDispatch()

  const { values = {}, setValues } = allForms || {}

  const { iot } = studentTabData || {}

  // ВРЕМЕННО (2026-06-23): см. комментарий у useEffect ниже
  const { events: eventsData } = studentTabData || {}

  const loading = currentTabLoading

  // ВРЕМЕННО (2026-06-23): мероприятия для ИОТ запрашиваем отдельным
  // GET tab=events, т.к. item.events из ответа tab=iot слишком скудные
  // ({ edid, name }). Убрать вместе с getYearEvents ниже, когда backend
  // начнёт отдавать полные данные мероприятий прямо в tab=iot.
  useEffect(() => {
    if (!addMode && studentId) {
      dispatch(getStudentTable('events', studentId))
    }
  }, [studentId, addMode, dispatch])

  // ВРЕМЕННО (2026-06-23): backend отдаёт tab=events сгруппированным по
  // направлениям ({ edid, name, events: [...] }). Для ИОТ сохраняем эту
  // группировку (направление = заголовок, events = содержание) и фильтруем
  // мероприятия каждого направления по диапазону года; направления без
  // подходящих мероприятий не показываем. Убрать вместе с остальным
  // временным кодом, когда backend начнёт отдавать полные данные
  // мероприятий прямо в tab=iot.
  const getYearEventGroups = (item) => {
    if (!Array.isArray(eventsData)) return []
    return eventsData
      .map(group => ({
        edid: group.edid,
        name: group.name,
        events: (Array.isArray(group.events) ? group.events : []).filter(event =>
          event.event_date >= item.begdate && event.event_date <= item.enddate
        )
      }))
      .filter(group => group.events.length > 0)
  }

  const lastSyncedRef = useRef(null)
  // Запоминает данные, актуальные на момент смены студента — пока studentTabData.iot
  // не заменится новым ответом сервера, эти данные считаются "устаревшими" и не синхронизируются в форму
  const staleIotRef = useRef(null)
  const [expandedYear, setExpandedYear] = useState(null)
  const [expandedBlocks, setExpandedBlocks] = useState({})
  const [expandedCourses, setExpandedCourses] = useState({})

  // При смене студента сбрасываем состояние аккордеона, кэш синхронизации и сами данные формы,
  // чтобы не показывать раскрытые года/данные предыдущего студента до прихода нового ответа
  useEffect(() => {
    staleIotRef.current = iot
    lastSyncedRef.current = null
    setExpandedYear(null)
    setExpandedBlocks({})
    setExpandedCourses({})
    if (!addMode && setValues) {
      setValues(prev => ({ ...prev, iot: [] }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentId])

  useEffect(() => {
    const dataJson = JSON.stringify(iot)
    const isStale = iot === staleIotRef.current
    if (!addMode && iot && !isStale && setValues && lastSyncedRef.current !== dataJson) {
      lastSyncedRef.current = dataJson
      setValues(prev => ({
        ...prev,
        iot: Array.isArray(iot) ? iot : []
      }))
      if (updateInitialValues) {
        updateInitialValues('iot', iot)
      }
      // Автоматически раскрываем первый (текущий) год если есть данные
      if (Array.isArray(iot) && iot.length > 0 && expandedYear === null) {
        setExpandedYear(iot[0].year_id)
      }
    }
  }, [iot, addMode, setValues, updateInitialValues, expandedYear])

  const rawData = Array.isArray(values.iot) ? values.iot : (Array.isArray(iot) ? iot : [])
  // Сортируем года по убыванию (самый новый — первым), независимо от порядка в ответе сервера
  const data = [...rawData].sort((a, b) => (b.begdate || '').localeCompare(a.begdate || ''))

  const getLessonsCount = (item) => {
    const main = (item.courses || []).reduce((sum, c) => sum + (c.lessons?.length || 0), 0)
    const extra = (item.courses_do || []).reduce((sum, c) => sum + (c.lessons?.length || 0), 0)
    return main + extra
  }

  const toggleCourse = (cid) => {
    setExpandedCourses(prev => ({
      ...prev,
      [cid]: !prev[cid]
    }))
  }

  const toggleYear = (yearId) => {
    setExpandedYear(prev => (prev === yearId ? null : yearId))
  }

  const toggleBlock = (key) => {
    setExpandedBlocks(prev => ({
      ...prev,
      [key]: !prev[key]
    }))
  }

  const renderCourseRow = (course, type) => {
    const isExpanded = expandedCourses[`${type}_${course.cid}`]
    const hasLessons = course.lessons && course.lessons.length > 0

    return (
      <Fragment key={`${type}_${course.cid}`}>
        <tr
          onClick={() => hasLessons && toggleCourse(`${type}_${course.cid}`)}
          style={{ cursor: hasLessons ? 'pointer' : 'default' }}
        >
          <td style={{ paddingLeft: '1rem' }}>
            {hasLessons && (
              <span style={{ marginRight: '0.5rem' }}>
                {isExpanded ? '▼' : '▶'}
              </span>
            )}
            {course.name}
          </td>
          <td>{course.teachers || '-'}</td>
          <td style={{ textAlign: 'center' }}>
            {course.average_grade ? course.average_grade.toFixed(2) : '-'}
          </td>
        </tr>
        {isExpanded && hasLessons && (
          <tr>
            <td colSpan={3} style={{ padding: 0, background: '#f9f9f9' }}>
              <table className={styles.admissionTable} style={{ margin: '0.5rem 1rem', width: 'calc(100% - 2rem)' }}>
                <thead>
                  <tr>
                    <th>Тема урока</th>
                    <th style={{ width: '100px' }}>Дата</th>
                    <th style={{ width: '80px' }}>Оценка</th>
                    <th style={{ width: '60px' }}>Вес</th>
                    <th>Комментарий</th>
                    <th>Домашнее задание</th>
                  </tr>
                </thead>
                <tbody>
                  {course.lessons.map((lesson, idx) => (
                    <tr key={idx}>
                      <td>{lesson.subject || '-'}</td>
                      <td>{lesson.lesson_date || '-'}</td>
                      <td style={{ textAlign: 'center' }}>{lesson.grade || '-'}</td>
                      <td style={{ textAlign: 'center' }}>{lesson.weight || '-'}</td>
                      <td>{lesson.grade_comment || '-'}</td>
                      <td>{lesson.homework || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
          </tr>
        )}
      </Fragment>
    )
  }

  return (
    <div className={styles.tabWrapper}>
      <h3 className={styles.iotTitle}>Индивидуальная образовательная траектория</h3>

      {loading ? (
        <div className={styles.iotLoader}>
          <Loader />
        </div>
      ) : data.length === 0 ? (
        <div className={styles.qualificationForm}>
          <p style={{ color: '#666', fontStyle: 'italic' }}>
            Нет данных по индивидуальной образовательной траектории
          </p>
        </div>
      ) : (
        <div className={styles.iotList}>
          {data.map((item, idx) => {
            const isExpanded = expandedYear === item.year_id
            const isCurrent = idx === 0
            const lessonsCount = getLessonsCount(item)
            const eventGroups = getYearEventGroups(item)
            const eventsCount = eventGroups.reduce((sum, g) => sum + g.events.length, 0)
            const hasDetails =
              (item.courses && item.courses.length > 0) ||
              (item.courses_do && item.courses_do.length > 0) ||
              eventGroups.length > 0

            return (
              <div key={item.year_id} className={styles.iotYearCard}>
                <div className={styles.iotYearHeader} onClick={() => toggleYear(item.year_id)}>
                  <span className={styles.iotClassBadge}>{item.group_name || '-'}</span>
                  <span className={styles.iotYearRange}>
                    {item.begdate?.slice(0, 4) || ''}–{item.enddate?.slice(0, 4) || ''}
                  </span>
                  {isCurrent && <span className={styles.iotCurrentBadge}>Текущий</span>}
                  <div className={styles.iotYearMeta}>
                    <span><b>{lessonsCount}</b> занятий</span>
                    <span><b>{eventsCount}</b> меропр.</span>
                    <span className={`${styles.iotChevron} ${isExpanded ? styles.iotChevronOpen : ''}`}>›</span>
                  </div>
                </div>

                {isExpanded && (
                  <div className={styles.iotYearDetails}>
                    {item.courses && item.courses.length > 0 && (() => {
                      const blockKey = `${item.year_id}_main`
                      const isBlockExpanded = !!expandedBlocks[blockKey]
                      return (
                        <div className={styles.qualificationForm}>
                          <div className={styles.iotBlockHeader} onClick={() => toggleBlock(blockKey)}>
                            <h3 className={styles.iotBlockTitle}>Основные предметы</h3>
                            <span className={`${styles.iotChevron} ${isBlockExpanded ? styles.iotChevronOpen : ''}`}>›</span>
                          </div>
                          {isBlockExpanded && (
                            <table className={styles.admissionTable}>
                              <thead>
                                <tr>
                                  <th>Предмет</th>
                                  <th style={{ width: '200px' }}>Преподаватель</th>
                                  <th style={{ width: '100px' }}>Средний балл</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.courses.map(course => renderCourseRow(course, 'main'))}
                              </tbody>
                            </table>
                          )}
                        </div>
                      )
                    })()}

                    {item.courses_do && item.courses_do.length > 0 && (() => {
                      const blockKey = `${item.year_id}_do`
                      const isBlockExpanded = !!expandedBlocks[blockKey]
                      return (
                        <div className={styles.qualificationForm}>
                          <div className={styles.iotBlockHeader} onClick={() => toggleBlock(blockKey)}>
                            <h3 className={styles.iotBlockTitle}>Дополнительное образование</h3>
                            <span className={`${styles.iotChevron} ${isBlockExpanded ? styles.iotChevronOpen : ''}`}>›</span>
                          </div>
                          {isBlockExpanded && (
                            <table className={styles.admissionTable}>
                              <thead>
                                <tr>
                                  <th>Предмет</th>
                                  <th style={{ width: '200px' }}>Преподаватель</th>
                                  <th style={{ width: '100px' }}>Средний балл</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.courses_do.map(course => renderCourseRow(course, 'do'))}
                              </tbody>
                            </table>
                          )}
                        </div>
                      )
                    })()}

                    {eventGroups.length > 0 && (() => {
                      const blockKey = `${item.year_id}_events`
                      const isBlockExpanded = !!expandedBlocks[blockKey]
                      return (
                        <div className={styles.qualificationForm}>
                          <div className={styles.iotBlockHeader} onClick={() => toggleBlock(blockKey)}>
                            <h3 className={styles.iotBlockTitle}>Мероприятия</h3>
                            <span className={`${styles.iotChevron} ${isBlockExpanded ? styles.iotChevronOpen : ''}`}>›</span>
                          </div>
                          {isBlockExpanded && (
                            // ВРЕМЕННО (2026-06-23): рендерим по направлениям (верхний уровень
                            // ответа tab=events — заголовок, его events — содержание); колонки
                            // внутри таблицы направления скопированы 1:1 с Events.jsx (включая
                            // её текущее расхождение comment/achievement_name с заголовками)
                            eventGroups.map(group => (
                              <div key={group.edid} style={{ marginTop: '0.5rem' }}>
                                <div style={{ fontWeight: 600, margin: '0.5rem 0 0.25rem' }}>{group.name}</div>
                                <table className={styles.admissionTable} style={{ tableLayout: 'fixed' }}>
                                  <thead>
                                    <tr>
                                      <th style={{ width: '90px' }}>Дата</th>
                                      <th style={{ width: '140px' }}>Уровень мероприятия</th>
                                      <th>Название мероприятия/Форма мероприятия</th>
                                      <th style={{ width: '150px' }}>Достижения</th>
                                      <th style={{ width: '60px' }}>Баллы</th>
                                      <th style={{ width: '110px' }}>Результаты</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {group.events.map(event => (
                                      <tr key={event.nid}>
                                        <td>{event.event_date ? moment(event.event_date).format('DD.MM.YYYY') : ''}</td>
                                        <td>{event.news_level_text || ''}</td>
                                        <td>{event.fullname || ''}</td>
                                        <td>{event.comment || ''}</td>
                                        <td>{event.total_ball || ''}</td>
                                        <td>{event.achievement_name || ''}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            ))
                          )}
                        </div>
                      )
                    })()}

                    {!hasDetails && (
                      <p style={{ color: '#666', fontStyle: 'italic', margin: '0.5rem 0 0' }}>
                        Нет данных за этот учебный год
                      </p>
                    )}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
